export const sizes = Object.freeze({
  Small: 'min-h-150 md:min-h-290',
  Medium: 'min-h-400',
  Large: 'h-[calc(100vh-96px)] min-h-400 md:h-auto lg:min-h-700',
});
